import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import ConversationExportsApi from 'dashboard/api/conversationExports';

export function useConversationExport() {
  const { t } = useI18n();
  const isLoading = ref(false);
  const isFetchingExports = ref(false);
  const recentExports = ref([]);

  const fetchRecentExports = async () => {
    isFetchingExports.value = true;
    try {
      const { data } = await ConversationExportsApi.getAll();
      recentExports.value = data;
    } catch {
      // silent — non-critical
    } finally {
      isFetchingExports.value = false;
    }
  };

  const createExport = async filters => {
    isLoading.value = true;
    try {
      await ConversationExportsApi.create(filters);
      useAlert(t('CONVERSATION.EXPORT.QUEUED_SUCCESS'));
      await fetchRecentExports();
    } catch {
      useAlert(t('CONVERSATION.EXPORT.QUEUED_ERROR'));
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    isFetchingExports,
    recentExports,
    fetchRecentExports,
    createExport,
  };
}
